/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Action_UnchangedInputs */

const cs_ebr_action_unchanged = /** @type {(inputs: Ebr_Action_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beze změny`)
};

const en_ebr_action_unchanged = /** @type {(inputs: Ebr_Action_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unchanged`)
};

/**
* | output |
* | --- |
* | "Unchanged" |
*
* @param {Ebr_Action_UnchangedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_action_unchanged = /** @type {((inputs?: Ebr_Action_UnchangedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Action_UnchangedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_action_unchanged(inputs)
	return cs_ebr_action_unchanged(inputs)
});